import { getTypes, runtimeEventManager } from "@wm/core";
import {
  assignWith,
  cloneDeep,
  extend,
  forEach,
  get,
  isArray,
  isEqual,
  isFunction,
  includes,
  isObject,
  keys,
  omit,
  sortBy,
  startsWith,
  toLower,
  isEmpty,
  xorWith, set, trim, split, camelCase
} from "lodash-es";
import { getValidJSON, noop } from "@wm/core";
import KeyDownEvent = JQuery.KeyDownEvent;
import { getWidgetRegistry } from '@wm/components-base'
import { environment } from "@wms/app";
import { Router, ActivatedRoute } from '@angular/router';
const semver = require('semver');

let listOfFiles:any = {};
export const HTTP_METHODS = ["GET", "POST", "PUT", "HEAD", "PATCH", "DELETE"];
export const NUMBER_TYPES = ['int', 'integer', 'float', 'double', 'long', 'short', 'byte', 'big_integer', 'big_decimal'];
export const REGEX = {
  SNAKE_CASE: /[A-Z]/g,
  ANDROID: /Android/i,
  IPHONE: /iPhone/i,
  IPOD: /iPod/i,
  IPAD: /iPad/i,
  MAC: /Mac/i,
  ANDROID_TABLET: /android|android 3.0|xoom|sch-i800|playbook|tablet|kindle/i,
  MOBILE: /Mobile/i,
  WINDOWS: /Windows Phone/i,
  SUPPORTED_IMAGE_FORMAT: /\.(bmp|gif|jpe|jpg|jpeg|tif|tiff|pbm|png|ico|svg)$/i,
  SUPPORTED_FILE_FORMAT: /\.(txt|js|css|html|script|properties|json|java|xml|xsd|xjb|smd|xmi|sql|log|wsdl|vm|ftl|jrxml|yml|yaml|md|less|jsp|ts|scss|sh|bat|tsx)$/i,
  SUPPORTED_AUDIO_FORMAT: /\.(mp3|ogg|webm|wma|3gp|wav|m4a)$/i,
  SUPPORTED_VIDEO_FORMAT: /\.(mp4|ogg|webm|wmv|mpeg|mpg|avi)$/i,
  PAGE_RESOURCE_PATH: /^\/pages\/.*\.(js|css|html|json)$/,
  MIN_PAGE_RESOURCE_PATH: /.*(page.min.html)$/,
  VALID_EMAIL: /^[a-zA-Z][\w.+]+@[a-zA-Z_]+?\.[a-zA-Z.]{1,4}[a-zA-Z]$/,
  VALID_WEB_URL: /^(http[s]?:\/\/)(www\.){0,1}[a-zA-Z0-9=:?\/\.\-]+(\.[a-zA-Z]{2,5}[\.]{0,1})?/,  //url-regex-validation
  VALID_WEBSOCKET_URL: /^(ws[s]?:\/\/)(www\.){0,1}[a-zA-Z0-9=:?\/\.\-]+(\.[a-zA-Z]{2,5}[\.]{0,1})?/,  //WebSocket url-regex-validation
  REPLACE_PATTERN: /\$\{([^\}]+)\}/g,
  ZIP_FILE: /\.zip$/i,
  EXE_FILE: /\.exe$/i,
  JAR_FILE: /\.jar$/i,
  NO_QUOTES_ALLOWED: /^[^'|"]*$/,
  NO_DOUBLE_QUOTES_ALLOWED: /^[^"]*$/,
  VALID_HTML: /<[a-z][\s\S]*>/i,
  VALID_PASSWORD: /^[0-9a-zA-Z-_.@&*!#$%]+$/,
  SPECIAL_CHARACTERS: /[^A-Z0-9a-z_]+/i,
  NON_ALPHABETS_AND_NUMBERS: /[^a-zA-Z0-9]/g,
  APP_SERVER_URL_FORMAT: /^(http[s]?:\/\/)(www\.){0,1}[a-zA-Z0-9\.\-]+([:]?[0-9]{2,5}|\.[a-zA-Z]{2,5}[\.]{0,1})(\/?)+[^?#&=]+$/,
  JSON_DATE_FORMAT: /\d{4}-[0-1]\d-[0-3]\d(T[0-2]\d:[0-5]\d:[0-5]\d.\d{1,3}Z$)?/,
  MOBILE_APP_ID: /^(([a-zA-Z]|[a-zA-Z][a-zA-Z0-9]*[a-zA-Z0-9])\.)*([A-Za-z]|[A-Za-z][A-Za-z0-9]*[A-Za-z0-9])$/,
  SPLIT_EXPRESSIONS: /({[^{]*}|\([^(]*\)|\[[^\[]*\]|"[^"]*"|'[^']*'|[^,])+/g, //Split at comma where comma is not present inside ''/[]/{}/()
  SPLIT_CLASS_NAME: /\s*?'[^']*'|[^(\s*?):].*/g //Match everyting after the first occurence of colen(:)
}
export const DB_CONSTANTS: any = {
  'DATABASE_MATCH_MODES': {
    'like': 'LIKE',
    'start': 'STARTING_WITH',
    'startignorecase': 'STARTING_WITH_IGNORECASE',
    'end': 'ENDING_WITH',
    'endignorecase': 'ENDING_WITH_IGNORECASE',
    'anywhere': 'CONTAINING',
    'anywhereignorecase': 'CONTAINING_IGNORECASE',
    'nowhere': 'DOES_NOT_CONTAIN',
    'nowhereignorecase': 'DOES_NOT_CONTAIN_IGNORECASE',
    'exact': 'EQUALS',
    'exactignorecase': 'EQUALS_IGNORECASE',
    'notequals': 'NOT_EQUALS',
    "notequalsignorecase": "NOT_EQUALS_IGNORECASE",
    'between': 'BETWEEN',
    'in': 'IN',
    "notin": "NOTIN",
    'lessthan': 'LESS_THAN',
    'lessthanequal': 'LESS_THAN_OR_EQUALS',
    'greaterthan': 'GREATER_THAN',
    'greaterthanequal': 'GREATER_THAN_OR_EQUALS',
    'null': 'NULL',
    'isnotnull': 'IS_NOT_NULL',
    'empty': 'EMPTY',
    'isnotempty': 'IS_NOT_EMPTY',
    'nullorempty': 'NULL_OR_EMPTY'
  },
  'DATABASE_EMPTY_MATCH_MODES': ['NULL', 'IS_NOT_NULL', 'EMPTY', 'IS_NOT_EMPTY', 'NULL_OR_EMPTY'],
  'DATABASE_RANGE_MATCH_MODES': ['IN', 'NOTIN', 'BETWEEN', 'LESS_THAN', 'LESS_THAN_OR_EQUALS', 'GREATER_THAN', 'GREATER_THAN_OR_EQUALS', 'NOT_EQUALS'],
  'DATABASE_NULL_EMPTY_MATCH': {
    'NULL': 'NULL',
    'IS_NOT_NULL': 'IS_NOT_NULL',
    'EMPTY': 'NULL',
    'IS_NOT_EMPTY': 'IS_NOT_NULL',
    'NULL_OR_EMPTY': 'NULL'
  },
  'DATABASE_MATCH_MODES_WITH_QUERY': {
    'LIKE': '${0} like ${1}',
    'STARTING_WITH': '${0} like ${1}',
    'STARTING_WITH_IGNORECASE': '${0} like ${1}',
    'ENDING_WITH': '${0} like ${1}',
    'ENDING_WITH_IGNORECASE': '${0} like ${1}',
    'CONTAINING': '${0} like ${1}',
    'CONTAINING_IGNORECASE': '${0} like ${1}',
    'DOES_NOT_CONTAIN': '${0} not like ${1}',
    'DOES_NOT_CONTAIN_IGNORECASE': '${0} not like ${1}',
    'EQUALS': '${0}=${1}',
    'EQUALS_IGNORECASE': '${0}=${1}',
    'NOT_EQUALS': '${0}!=${1}',
    "NOT_EQUALS_IGNORECASE": "${0}!=${1}",
    'BETWEEN': '${0} between ${1}',
    'IN': '${0} in ${1}',
    'NOTIN': "${0} not in ${1}",
    'LESS_THAN': '${0}<${1}',
    'LESS_THAN_OR_EQUALS': '${0}<=${1}',
    'GREATER_THAN': '${0}>${1}',
    'GREATER_THAN_OR_EQUALS': '${0}>=${1}',
    'NULL': '${0} is null',
    'IS_NOT_NULL': '${0} is not null',
    'EMPTY': '${0}=\'\'',
    'IS_NOT_EMPTY': '${0}<>\'\'',
    'NULL_OR_EMPTY': '${0} is null or ${0}=\'\''
  },
  'DATABASE_STRING_MODES': ['LIKE', 'STARTING_WITH', 'STARTING_WITH_IGNORECASE', 'ENDING_WITH', 'ENDING_WITH_IGNORECASE', 'CONTAINING', 'CONTAINING_IGNORECASE', 'DOES_NOT_CONTAIN', 'DOES_NOT_CONTAIN_IGNORECASE', 'EQUALS', 'EQUALS_IGNORECASE', 'NOT_EQUALS', "NOT_EQUALS_IGNORECASE"],
  'DATABASE_DATA_TYPES': {
    "big_decimal": {
      "java_type": "big_decimal"
    },
    "big_integer": {
      "java_type": "big_integer"
    },
    "blob": {
      "java_type": "blob"
    },
    "boolean": {
      "java_type": "boolean"
    },
    "byte": {
      "java_type": "byte"
    },
    "character": {
      "java_type": "character"
    },
    "clob": {
      "java_type": "clob"
    },
    "date": {
      "java_type": "date"
    },
    "datetime": {
      "java_type": "datetime"
    },
    "double": {
      "java_type": "double"
    },
    "float": {
      "java_type": "float"
    },
    "integer": {
      "java_type": "integer"
    },
    "long": {
      "java_type": "long"
    },
    "string": {
      "java_type": "string"
    },
    "short": {
      "java_type": "short"
    },
    "text": {
      "java_type": "text"
    },
    "time": {
      "java_type": "time"
    },
    "timestamp": {
      "java_type": "timestamp"
    },
    "unknown": {
      "java_type": "blob"
    }
  },
  'DATABASE_SECONDARY_DATA_TYPES': {
    "binary": {
      "java_type": "blob"
    },
    "long": {
      "java_type": "double"
    }
  },
  'PERMISSIONS': {
    "DEFAULT": {
        "CREATE": true,
        "UPDATE": true,
        "DELETE": true,
        "READ": true
    },
    "HSQLDB": {
        "CREATE": false,
        "UPDATE": false,
        "DELETE": false,
        "READ": true
    },
    "MySQL-Cloud": {
        "CREATE": true,
        "UPDATE": true,
        "DELETE": true,
        "READ": true
    },
    "MySQL": {
        "CREATE": true,
        "UPDATE": true,
        "DELETE": true,
        "READ": true
    },
    "DB2": {
        "CREATE": false,
        "UPDATE": false,
        "DELETE": false,
        "READ": true
    },
    "PostgreSQL": {
        "CREATE": true,
        "UPDATE": true,
        "DELETE": true,
        "READ": true
    },
    "Oracle": {
        "CREATE": true,
        "UPDATE": true,
        "DELETE": true,
        "READ": true
    },
    "Redshift": {
        "CREATE": true,
        "UPDATE": true,
        "DELETE": true,
        "READ": true
    },
    "SAP_HANA": {
        "CREATE": true,
        "UPDATE": true,
        "DELETE": true,
        "READ": true
    },
    "SQLServer": {
        "CREATE": true,
        "UPDATE": true,
        "DELETE": true,
        "READ": true
    },
    "Other": {
        "CREATE": false,
        "UPDATE": false,
        "DELETE": false,
        "READ": true
    },
    "RE_IMPORT_CASE": {
        "CREATE": false,
        "UPDATE": false,
        "DELETE": false,
        "READ": true,
        "VIEWONLY": true
    }
  },
  "MYSQL_CLOUD_HOST" : "{WM_CLOUD_MYSQL_HOST}",
  'DB_TYPES': {
    'HSQL_DB_TYPE': 'HSQLDB',
    'MYSQL_DB_TYPE': 'MySQL',
    'POSTGRESQL_DB_TYPE': 'PostgreSQL',
    'ORACLE_DB_TYPE': 'Oracle',
    'SQL_SERVER_DB_TYPE': 'SQLServer',
    'DB2_DB_TYPE': 'DB2',
    'REDSHIFT_DB_TYPE': 'Redshift',
    'SAP_HANA_DB_TYPE': 'SAP_HANA',
    'MYSQL_CLOUD_DB_TYPE': 'MySQL-Cloud',
    'OTHER': 'Other'
  },
  'NON_EDITABLE_DATABASE_SYSTEMS':[ 'Redshift', 'SAP_HANA', 'HSQLDB', 'DB2', 'Other' ],
  'WAVEMAKER_SAMPLE_DATABASES': ['hrdb', 'salesdb'],
  'LOGIN': {
    'SAAS_MYSQL_CLOUD':{
      'USERNAME' : '{WM_CLOUD_MYSQL_USERNAME}',
      'PASSWORD' : '{WM_CLOUD_MYSQL_PASSWORD}'
    }
  },
  'DRIVER_VERSIONS': {
    'DB2': [
      {
          'DB_VERSION': '11.5',
          'DRIVER_VERSION': 'db2jcc4.jar',
          'URL': ''
      }
    ],
   'Oracle':[
     {
        'DB_VERSION': 'Oracle 19c',
        'DRIVER_VERSION': 'ojdbc8.jar',
        'URL': '',
        '$$hashKey': 'object:360'
     },
     {
       'DB_VERSION': 'Oracle 23c',
       'DRIVER_VERSION': 'ojdbc11.jar',
       'URL': '',
       '$$hashKey': 'object:360'
     },
    ],
    'SQLServer':[
      {
          'DB_VERSION': 'SQL Server 2019',
          'DRIVER_VERSION': 'Driver 9.2',
          'URL': ''
      },
      {
          'DB_VERSION': 'Azure SQL Database',
          'DRIVER_VERSION': 'Driver 9.2',
          'URL': ''
      },
      {
        'DB_VERSION': 'SQL Server 2022',
        'DRIVER_VERSION': 'Driver 9.2',
        'URL': ''
      }
  ],
    'MySQL':[
      {
        'DB_VERSION':'8.0.21',
        'URL': ''
      },
      {
        'DB_VERSION':'8.4.3',
        'URL': ''
      },
      {
        'DB_VERSION':'9.1.0',
        'URL': ''
      },
    ],
    'PostgreSQL':[
      {
        'DB_VERSION':'13.8',
        'URL': ''
      },
      {
        'DB_VERSION':'17.0',
        'URL': ''
      },
    ]
  },
  "SEQUENCE_SUPPORTED_DB_TYPES": [
    "HSQLDB",
    "PostgreSQL",
    "Oracle",
    "SAP_HANA",
    "SQLServer",
    "DB2",
    "Other"
  ],
  "GENERATOR_TYPES": {
  "ASSIGNED": "assigned",
  "SEQUENCE": "sequence",
  "IDENTITY": "identity"
  },
  "DML_QUERY_INDICATORS":{
    "SELECT": "SELECT",
    "UPDATE": [
        "INSERT",
        "UPDATE",
        "DELETE"
    ]
  },
  "DDL_QUERY_INDICATORS": [
    "CREATE",
    "ALTER",
    "RENAME",
    "DROP"
  ],
  "SERVER_SIDE_PROPERTIES": {
    "CURRENT_DATE": {
        "property": "Current Date",
        "label": "CURRENT_DATE",
        "value": "DATE"
    },
    "CURRENT_TIME": {
        "property": "Current Time",
        "label": "CURRENT_TIME",
        "value": "TIME"
    },
    "CURRENT_DATE_TIME": {
        "property": "Current DateTime",
        "label": "CURRENT_DATE_TIME",
        "value": "DATETIME"
    },
    "CURRENT_TIMESTAMP": {
        "property": "Current Timestamp",
        "label": "CURRENT_TIMESTAMP",
        "value": "TIMESTAMP"
    },
    "CURRENT_USER_ID": {
        "property": "LoggedIn UserId",
        "label": "CURRENT_USER_ID",
        "value": "USER_ID"
    },
    "CURRENT_USER_NAME": {
        "property": "LoggedIn Username",
        "label": "CURRENT_USER_NAME",
        "value": "USER_NAME"
    }
  },
  "PROCEDURE_INDICATORS": {
    CALL: "CALL",
    EXECUTE: "EXEC",
    SELECT: "SELECT"
  },
  "ACTIONS":{
    "CREATE": "CREATE",
    "UPDATE": "UPDATE",
    "DELETE": "DELETE",
    "SAVED": "SAVED"
  },
  "OBJECTS":{
    "DATABASE": "wm-db",
    "TABLE": "wm-db-table",
    "COLUMN": "wm-db-table-column",
    "RELATION": "wm-db-column-relation"
  },
  "WIDGET_TYPES": {
    "VIEW": "view"
  },
  "COLUMN_VALUE_TYPES":{
    "user-defined": "User Defined",
    "server-defined": "Server Defined",
    "database-defined": "Database Defined",
    "app-environment-defined": "App Environment Defined"
  },
  "COLUMN_SERVER_PROPERTIES":{
    "DATE": "Current Date",
    "TIME": "Current Time",
    "TIMESTAMP": "Current Timestamp",
    "DATE_TIME": "Current Datetime",
    "USER_ID": "LoggedIn UserId",
    "USER_NAME": "LoggedIn Username"
},
  "RELATION_CASCADE_OPTIONS":{
  "NONE": "None",
  "REMOVE": "Remove"
}
};

interface UrlParam {
  key: string;
  value: string | number | null | undefined;
  isFragment?: boolean;
}

export const PROPERTIES: any = {
  "wm.plugins.database.base": {
    "dbobjectname": { "type": "string", "required": true, "maxlength": 64 }
  },
  "wm.plugins.database.db": {
    "package": { "type": "string", "required": true, "disabled": true }
  },
  "wm.plugins.database.table.base": {
    "entityname": { "type": "string", "disabled": true },
    "type": { "type": "string", "disabled": true },
    "schema": { "type": "schemaoptions", "value": "", "disabled": true },
    "catalog": { "type": "string", "required": true, "disabled": true },
    "defaultfilter": { "type": "string", "required": false, "disabled": false },
    "primarykey": { "type": "primarykeyoptions", "show": true },
    "uniquekey": { "type": "uniquekeyoptions", "show": true },
    "pktype": { "type": "list", "required": true, "disabled": false, "value": 'single', "options": { single: 'single', composite: 'composite' }, "show": true },
    "vpk": { "type": "boolean", "value": false, "disabled": false, "show": false },
    "columns": { "type": "list", "options": {}, "value": "", "show": true }
  },
  "wm.plugins.database.table.temporals": {
    "temporaltype": { "type": "string", "disabled": true, "show": true }
  },
  "wm.plugins.database.column.base": {
    "fieldname": { "type": "string", "disabled": true },
    "sqltype": { "type": "list", "required": true, "options": {}, "value": "string" },
    "javatype": { "type": "list", "required": true, "options": {}, "value": "string" },
    "length": { "type": "number", "show": false, "required": true, "value": 255, "min": 1 },
    "precision": { "type": "number", "show": false, "required": true, "min": 1 },
    "scale": { "type": "number", "show": false, "required": true, "min": 0 }
  },
  "wm.plugins.database.column.temporal": {
    "temporalcolumntype": { "type": "string", "disabled": true, show: true },
    "ishidden": { "type": "boolean", "value": false, "disabled": false }
  },
  "wm.plugins.database.column.constraints": {
    "nullable": { "type": "boolean", "value": true },
    "ispk": { "type": "boolean", "value": false, "show": false },
    "unique": { "type": "boolean", "value": false, "disabled": true },
    "partofuniquekey": { "type": "boolean", "value": false, "disabled": true },
    "isfk": { "type": "boolean", "value": false, "disabled": true },
    "ispartofpk": { "type": "boolean", "value": false, "disabled": true },
    "generatortype": { "type": "label", "options": DB_CONSTANTS.DATABASE_GENERATORS, "value": "" },
    "generatorvalue": { "type": "label", "required": true },
    "virtualpk": { "type": "boolean", "value": false, "disabled": true, "show": false },
    "columnidentifier": { "type": "string", "value": "", show: false }
  },
  "wm.plugins.database.column.datavalue": {
    "defaultvalue": { "type": "string", "value": "", "show": true },
    "valuetype": { "type": "list", "options": {}, "value": "user-defined", "show": true, "required": true },
    "serverproperty": { "type": "list", "options": {}, "value": "", show: false, "required": true },
    "appenvproperty": { "type": "list", "options": {}, "value": "", show: false, "required": true },
    "userinsertable": { "type": "boolean", "value": true, "show": true, "disabled": false },
    "userupdatable": { "type": "boolean", "value": true, "show": true, "disabled": false },
    "serverinsertable": { "type": "boolean", "value": true, "show": true, "disabled": false },
    "serverupdatable": { "type": "boolean", "value": true, "show": true, "disabled": false },
    "databaseinsertable": { "type": "boolean", "value": false, "show": true, "disabled": true },
    "databaseupdatable": { "type": "boolean", "value": false, "show": true, "disabled": true },
    "appenvinsertable": { "type": "boolean", "value": true, "show": true, "disabled": false },
    "appenvupdatable": { "type": "boolean", "value": true, "show": true, "disabled": false },
    "validators": { "type": "validatorslist", "options": {}, "required": true, "value": "", show: true }
  },
  "wm.plugins.database.relation": {
    "fieldname": { "type": "string", "disabled": true },
    "targettable": { "type": "string", "required": true, "disabled": true },
    "cardinality": { "type": "string", "required": true, "disabled": true },
    "sourcetable": { "type": "string", "required": true, "disabled": true },
    "relatedcolumns": { "type": "table", "required": true, "disabled": true },
    "virtual": { "type": "boolean", "required": false, "disabled": true }
  },
  "wm.plugins.database.relation.fetchoptions": {
    "fetchparent": { "type": "boolean", "value": true, "show": true, "disabled": false },
    "parentcolumnsfilter": { "type": "fetchtableoptions", "show": true }
  },
  "wm.plugins.database.relation.cascadeoptions": {
    "cascadeenabled": { "type": "boolean", "value": false, "show": true, "disabled": false },
    "cascaderemove": { "type": "cascadelist", "options": DB_CONSTANTS.RELATION_CASCADE_OPTIONS, "value": "NONE", "show": true, "required": true }
  },
  "DATABASE_GENERATORS" : {
    "assigned": "assigned",
    "identity": "auto increment",
    "uniqueid": "unique id",
    "sequence": "sequence"
  },
}
let method: Function;
export const DATA_SEARCH_LIMIT = 10;

export const VARIABLE_CATEGORY_MAP: any = {
  'wm.Variable': 'variable',
  'wm.ServiceVariable': 'service-variable',
  'wm.CrudVariable': 'crud-variable',
  'wm.LiveVariable': 'live-variable',
  'wm.LoginVariable': 'login-variable',
  'wm.LogoutVariable': 'logout-variable',
  'wm.NavigationVariable': 'navigation-variable',
  'wm.NotificationVariable': 'notification-variable',
  'wm.TimerVariable': 'timer-variable',
  'wm.DeviceVariable': 'device-variable',
  'wm.WebSocketVariable': 'websocket-variable'
}

export const DATE_PATTERNS: any = ['yyyy-MM-dd', 'yyyy-M-dd', 'M-dd-yyyy', 'MM-dd-yy', 'yyyy, dd MMMM', 'yyyy, MMM dd', 'MM/dd/yyyy', 'M/d/yyyy', 'EEE, dd MMM yyyy', 'EEE MMM dd yyyy', 'EEEE, MMMM dd, yyyy', "timestamp"];
export const DATE_TIME_PATTERNS: any = ["dd/MM/yyyy", "yyyy-MM-dd", "yyyy-M-dd", "M-dd-yyyy", "M/d/yyyy", "MM/dd/yyyy", "yyyy, MMM dd", "yyyy, dd MMMM", "yyyy-MM-ddTHH:mm:ss", "MM-dd-yy hh:mm:ss a", "MM-dd-yy hh:mm:ss a Z", "dd-MMM-yyyy HH:mm:ss", "yyyy-MM-dd HH:mm", "yyyy-MM-dd HH:mm:ss:sss", "yyyy-MM-dd hh:mm a", "yyyy-MM-dd hh:mm:ss a", "yyyy-MM-dd hh:mm:ss:sss Z", "yyyy-MM-dd hh:mm:ss:sss a", "EEE MMM dd hh:mm:ss Z yyyy", "EEE, dd MMM yyyy HH:mm:ss Z", "EEEE, MMMM dd, yyyy", "timestamp", "MMM, yyyy", "UTC"];
export const TIME_PATTERNS: any = ['HH:mm:ss', 'HH:mm', 'hh:mm:ss', 'hh:mm', 'hh:mm a', 'H:m:s', 'h:m:s', 'timestamp'];
export const CURRENCY_OPTIONS: any = ["AED", "AFN", "ALL", "AMD", "ARS", "AUD", "AZN", "BAM", "BDT", "BGN", "BHD", "BIF", "BND", "BOB", "BRL", "BWP", "BYR", "BZD", "CAD", "CDF", "CHF", "CLP", "CNY", "COP", "CRC", "CVE", "CZK", "DJF", "DKK", "DOP", "DZD", "EEK", "EGP", "ERN", "ETB", "EUR", "GBP", "GEL", "GHS", "GNF", "GTQ", "HKD", "HNL", "HRK", "HUF", "IDR", "ILS", "INR", "IQD", "IRR", "ISK", "JMD", "JOD", "JPY", "KES", "KHR", "KMF", "KRW", "KWD", "KZT", "LBP", "LKR", "LTL", "LVL", "LYD", "MAD", "MDL", "MGA", "MKD", "MMK", "MOP", "MUR", "MXN", "MYR", "MZN", "NAD", "NGN", "NIO", "NOK", "NPR", "NZD", "OMR", "PAB", "PEN", "PHP", "PKR", "PLN", "PYG", "QAR", "RON", "RSD", "RUB", "RWF", "SAR", "SDG", "SEK", "SGD", "SOS", "SYP", "THB", "TND", "TOP", "TRY", "TTD", "TWD", "TZS", "UAH", "UGX", "USD", "UYU", "UZS", "VEF", "VND", "XAF", "XOF", "YER", "ZAR", "ZMK"];
export const FORMAT_OPTIONS: any = ["custom", "toDate", "toCurrency", "prefix", "suffix", "numberToString", "stringToNumber", "timeFromNow", "None"];
export const SECURITY_CONTEXT_OPTIONS: any = ["html", "url"];
export const customFilters: any = {};

export const operators = ['+', '-', '*', '/', '=', '<', '>', '&', '|', '^', '(', ')', '!', '%', '[', ']', '{', '}', ',', ';'];
export const bindExpressionRegEx = new RegExp('[?:(' +
  operators.map(function (op) {
    return '\\' + op;
  }
  ).join('|') + ')]', 'g');

export const dataSetWidgets = {
  'select': true,
  'checkboxset': true,
  'radioset': true,
  'switch': true,
  'autocomplete': true,
  'chips': true,
  'typeahead': true,
  'rating': true
}

export function getDataSetWidgets() {
  return dataSetWidgets;
}

export function getDateTimePatterns() {
  return DATE_TIME_PATTERNS;
}
export function getDatePatterns() {
  return DATE_PATTERNS;
}
export function getTimePatterns() {
  return TIME_PATTERNS;
}
export function getCurrencyOptions() {
  return CURRENCY_OPTIONS;
}
export function getFormatPatterns() {
  return FORMAT_OPTIONS;
}
export function getSecurityContextOptions() {
  return SECURITY_CONTEXT_OPTIONS;
}

export function triggerFn(fn: any, ...argmnts: any) {
  /* Use of slice on arguments will make this function not optimizable
  * https://github.com/petkaantonov/bluebird/wiki/Optimization-killers#32-leaking-arguments
  * */

  let start = 1;
  const len = arguments.length, args = new Array(len - start);
  for (start; start < len; start++) {
    args[start - 1] = arguments[start];
  }

  if (isFunction(fn)) {
    return fn.apply(null, args);
  }
}

export function toJson(obj: any, pretty?: any): any {
  if (isUndefined(obj)) return undefined;
  if (!isNumber(pretty)) {
    pretty = pretty ? 2 : null;
  }
  return JSON.stringify(obj, toJsonReplacer, pretty);
}

export function fromJson(json: any) {
  return isString(json)
    ? JSON.parse(json)
    : json;
}

export function isString(value: any) {
  return typeof value === 'string';
}

export function toJsonReplacer(key: any, value: any) {
  let val = value;

  if (typeof key === 'string' && key.charAt(0) === '$' && key.charAt(1) === '$') {
    val = undefined;
  } else if (isWindow(value)) {
    val = '$WINDOW';
  } else if (value && window.document === value) {
    val = '$DOCUMENT';
  } else if (isScope(value)) {
    val = '$SCOPE';
  }

  return val;
}

export function isNumber(value: any) { return typeof value === 'number'; }

export function isUndefined(value: any) { return typeof value === 'undefined'; }

export function isWindow(obj: any) {
  return obj && obj.window === obj;
}

export function getMatchModes() {
  return {
    'startignorecase': 'Starts with ignore case',
    'start': 'Starts with',
    'endignorecase': 'Ends with ignore case',
    'end': 'Ends with',
    'anywhereignorecase': 'Contains ignore case',
    'anywhere': 'Contains',
    'exact': 'Is equal to',
    'exactignorecase': 'Is equal to ignore case'
  };
}

/*to check duplicate names*/
export function isDuplicateName(list: any, newName: string, caseSensitive?: boolean) {
  let retVal = false,
    i;
  /* if list or name doesn't exist, return  */
  if (!list || !newName) {
    return retVal;
  }
  if (caseSensitive) {
    for (i = 0; i < list.length; i += 1) {
      /* if name found in list, return true */
      if (list[i].toLowerCase() === newName.toLowerCase()) {
        retVal = true;
        break;
      }
    }
  } else {
    if (list.indexOf(newName) !== -1) {
      retVal = true;
    }
  }
  return retVal;
}


export function isScope(obj: any) {
  return obj && obj.$evalAsync && obj.$watch;
}

/*Function that checks if the dataset is valid or not*/
export function isValidDataSet(dataset: any) {
  return ((isArray(dataset) && dataset.length > 0) || (isObject(dataset) && Object.keys(dataset).length > 0));
}

const getHeadNode = () => {
  return $('head')[0];
}

const getScriptEl = (): HTMLElement => {
  return document.createElement('script');
}

/*function to check if the script is already loaded*/
function isScriptLoaded(src: string) {
  return $('script[src="' + src + '"]').length > 0 || $('script[data-src="' + src + '"]').length > 0;
}

/* util function to load the content from a url */
export const fetchContent = (url: string, options?: any) => {
  if (!method) {
    method = runtimeEventManager.getService('fetchContent');
  }
  return method(url, options);
}

const getScript = (url: string): Promise<any> => {
  return fetchContent(url, { responseType: 'text' }).then((scriptContent: string) => {
    const scriptElement = document.createElement('script');
    scriptElement.innerHTML = scriptContent;
    document.body.appendChild(scriptElement);
    return Promise.resolve();
  });
}

const prepareScriptPromises = (scripts: Array<string>, $promises: Array<Promise<any>> = []): Array<Promise<any>> => {
  let url = scripts.shift();
  if (!url) {
    return $promises;
  }
  if (isScriptLoaded(url)) {
    return prepareScriptPromises(scripts, $promises);
  }

  $promises.push(getScript(url));
  return prepareScriptPromises(scripts, $promises);
}

export const stringStartsWith = (str: string, startsWith: string, ignoreCase?: boolean): boolean => {
  if (!str) {
    return false;
  }

  const regEx = new RegExp('^' + startsWith, ignoreCase ? 'i' : '');

  return regEx.test(str);
};

export const stringEndsWith = (str: string, endsWith: string, ignoreCase?: boolean): boolean => {
  if (!str) {
    return false;
  }

  const regEx = new RegExp(endsWith + '$', ignoreCase ? 'i' : '');

  return regEx.test(str);
}

// function to load stylesheets
export const loadStyleSheets = (urls: string[] = []) => {
  // if the first argument is not an array, convert it to an array
  if (!Array.isArray(urls)) {
    urls = [urls];
  }
  urls.forEach(loadStyleSheet);
};

export const loadScripts = (scripts: Array<string>): Promise<any> => {
  let promises = prepareScriptPromises(scripts, []);
  return Promise.all(promises);
}

const loadScriptsInSync = (urlArray: Array<string>) => {

  if (urlArray.length === 0) {
    return;
  }

  const url = urlArray.shift();

  if (!url || isScriptLoaded(url)) {
    return;
  }

  if (url) {
    fetchContent(url).then((response: any) => {
      let script: HTMLScriptElement = getScriptEl().cloneNode() as HTMLScriptElement;
      set(script, 'text', response);
      script.setAttribute('data-src', url);
      getHeadNode().appendChild(script);
      loadScriptsInSync(urlArray);
    }, () => { }); //load in sync
  }
}

export function prettifyLabel(label: string) {
  label = camelCase(label);
  /*capitalize the initial Letter*/
  label = initCaps(label);
  /*Convert camel case words to separated words*/
  label = spaceSeparate(label);
  /*Replace '.' with space and capitalize the next letter*/
  label = periodSeparate(label);
  return label;
}

/* convert camelCase string to a space separated string */
export function spaceSeparate(name: string) {
  if (name === name.toUpperCase()) {
    return name;
  }
  return name.replace(REGEX.SNAKE_CASE, function (letter, pos) {
    return (pos ? ' ' : '') + letter;
  });
}

/*Replace '.' with space and capitalize the next letter*/
export function periodSeparate(name: string) {
  let dotIndex;
  dotIndex = name.indexOf('.');
  if (dotIndex !== -1) {
    name = replaceAt(name, dotIndex + 1, name.charAt(dotIndex + 1).toUpperCase());
    name = replaceAt(name, dotIndex, ' ');
  }
  return name;
}

/*Replace the character at a particular index*/
export function replaceAt(string: string, index: any, character: string) {
  return string.substr(0, index) + character + string.substr(index + character.length);
}


// expose the methods on the service instance.

export const sort = (collection: Array<any>, key?: string, caseSensitive?: boolean) => {
  return sortBy(collection, (item) => {
    if (item) {
      return key
        ? ((item[key] && !caseSensitive && item[key].toLowerCase) ? item[key].toLowerCase() : item[key]) //object
        : !caseSensitive && item.toLowerCase ? item.toLowerCase() : item; //array
    }
  });
}

/**
 * Returns a deep cloned replica of the passed object/array
 * @param object object/array to clone
 * @returns a clone of the passed object
 */
export const getClonedObject = (object: object) => {
  return cloneDeep(object);
}

// Valid field name should not contain any special chars other than _ and $
export const isValidFieldName = (fieldName: string) => {
  return (/^[0-9a-zA-Z_\$]+$/.test(fieldName));
}

/*Function to check whether the specified object is a pageable object or not.*/
export const isPageable = (obj: any): boolean => {
  const pageable = {
    'content': [],
    'first': true,
    'last': true,
    'number': 0,
    'numberOfElements': 10,
    'size': 20,
    'sort': null,
    'totalElements': 10,
    'totalPages': 1
  };
  return isEqual(keys(pageable), keys(obj).sort());
};

/*
* extracts and returns the last bit from full typeRef of a field
* e.g. returns 'String' for typeRef = 'java.lang.String'
* @params: {typeRef} type reference
*/
export const extractType = (typeRef: any): any => {
  let type;
  if (!typeRef) {
    return 'string';
  }
  type = typeRef && toLower(typeRef.substring(typeRef.lastIndexOf('.') + 1));
  type = type === 'localdatetime' ? 'datetime' : type;
  return type;
}

export const isEmptyObject = (obj: any) => {
  if (isObject(obj) && !Array.isArray(obj)) {
    return Object.keys(obj).length === 0;
  }
  return false;
}

/* returns true if the provided data type matches number type */
export const isNumberType = (type: any) => {
  return (NUMBER_TYPES.indexOf(extractType(type).toLowerCase()) !== -1);
}

/* to handle special characters used while defining variables and page params */
export const checkSpecialCharacters = (str: string) => {
  if (hasSpecialCharacters(str)) {
    if (includes(str, "'")) {
      str = str.replace(/'/g, "\\'");
    }
    return str = "['" + str + "']";
  } else {
    return str;
  }
}

/*function to check if the string contains special characters*/
export const hasSpecialCharacters = (str: string) => {
  return REGEX.SPECIAL_CHARACTERS.test(str);
}

/**
 * Returns true, if the given value is a JSON serialized form of date.
 *
 * @param str
 * @returns {boolean}
 */
export const isJSONDate = (str: string) => {
  return isString(str) && REGEX.JSON_DATE_FORMAT.test(str);
}

//widget function
export const byType = (types: any) => {
  let registry = getWidgetRegistry();
  /* if type not provided, return all widgets */
  if (!types) {
    return registry;
  }

  /* if comma separated types are provided, make it an array*/
  if (typeof types === "string") {
    /* if form-widgets required */
    if (includes(['form-widgets', 'page-container-widgets', 'dialog-widgets', 'spinner-widgets'], types)) {
      types = getTypes(types);
    } else {
      types = types.split(",");
    }
  }

  let collection: any = {};

  forEach(types, (type) => {
    type = type.trim();
    registry.forEach((widget: any) => {
      // TODO : widget.getAttr('formcontrolname')
      if ( widget.widgetType === type && !widget.nativeElement?.getAttribute('formcontrolname') && widget['name']) {
        collection[widget['name']] = widget;
      }
    });
  });
  return collection;
}

runtimeEventManager.setService('getWidgetsByType', byType);

export const formatVariableIconClass = (variableCategory: string) => {
  return VARIABLE_CATEGORY_MAP[variableCategory];
}

/*function to get the metadata structure (columns) from the data*/
export const getMetaDataFromData = (data: any) => {
  let dataObject: any;
  if (Array.isArray(data)) {
    if (isObject(data[0])) {
      dataObject = getClonedObject(data[0]);
      /*Loop over the object to find out any null values. If any null values are present in the first row, check and assign the values from other row.
       * As column generation is dependent on data, for related fields if first row value is null, columns are not generated.
       * To prevent this, check the data in other rows and generate the columns. New keys from others rows are also added*/
      forEach(data, (row, index) => {
        if ((index + 1) >= DATA_SEARCH_LIMIT) { //Limit the data search to first 10 records
          return false;
        }
        assignWith(dataObject, row, (objValue, srcValue) => {
          return (objValue === null || objValue === undefined) ? srcValue : objValue;
        });
        return;
      });
    } else {
      dataObject = data[0];
    }
  } else {
    dataObject = data;
  }
  return dataObject;
}

/* to replace non alphabetic and non numeric characters with underscores */
export const specialCharactersToUnderscores = (str: string) => {
  return str.replace(REGEX.NON_ALPHABETS_AND_NUMBERS, '_');
}

export const findValueOf = (obj: any, key: any, create?: any) => {
  if (!obj || !key) {
    return;
  }
  if (!create) {
    return get(obj, key);
  }
  let parts = key.split('.'),

    keys: any = [],
    skipProcessing;
  forEach(parts, (part): any => {
    if (!parts.length) {
      skipProcessing = true;
      return false;
    }
    let subParts = part.match(/\w+/g),
      subPart;
    while (subParts.length) {
      subParts = subParts.shift();
      keys.push({ 'key': subPart, 'value': subParts.length ? [] : {} });
    }
  });

  if (skipProcessing) {
    return undefined;
  }
  forEach(keys, (_key: any): any => {
    let tempObj = obj[_key.key];
    if (isObject(tempObj)) {
      tempObj = getValidJSON(tempObj);
      if (!tempObj) {
        tempObj = _key.value;
      }
    }
    obj[_key.key] = tempObj;
    obj = tempObj;
  });
  return obj;
}

export const isEmptObject = (obj: any) => {
  if (isObject(obj) && isArray(obj)) {
    return Object.keys(obj).length === 0;
  }
  return false;
}

/* capitalize the first-letter of the string passed */
export const initCaps = (name: string) => {
  if (!name) {
    return '';
  }
  return name.charAt(0).toUpperCase() + name.substring(1);
};

export function getDecodedData(content: string): any {
  let val;
  try {
    val = decodeURIComponent(content.replace(/\+/g, ' '));
  } catch (e) {
    val = content;
  }
  return val;
}
/**
 * This method removes double slashes in the url
 * e.g. "https://abc.com/service//hrdb/employee//api" will be returned as "https://abc.com/service/hrdb/employee/api"

 * Exceptions:
 * if the url starts with //, https://, http://, wss://, ws:// etc ignore these double slashes
 * if double slashes present in the url apart from the above places, replace the double slashes with single slash

 * @param url, string URL where double slashes will be removed
 * @returns {url}, sanitized url
 */
export const removeExtraSlashes = (url: string) => {
  let base64regex = /^data:image\/([a-z]{2,});base64,/;
  if (isString(url)) {
    /*
    * support for mobile apps having local file path url starting with file:/// and
    * support for base64 format
    * */
    if (startsWith(url, 'file:///') || base64regex.test(url)) {
      return url;
    }
    return url.replace(new RegExp('([^:]\/)(\/)+', 'g'), '$1');
  }
  return;
}

export const preventCachingOf = (url: any) => {
  return url;
}

/**
 * This function is used to get custom header value to set while making xhr calls
 * @param headerName
 * @returns {*}
 */
export const getCustomHeaderVal = (headerName: string) => {
  let headerValue = null;
  switch (headerName) {
    //TODO
    // case CUSTOM_HTTP_HEADERS.WM_PLATFORM_VERSION:
    //   if (this.root.project && $rootScope.project.platformVersion) {
    //     headerValue = $rootScope.project.platformVersion;
    //   }
    //   break;
    default:
      //do nothing;
      break;
  }
  return headerValue;
}
export const isAppleProduct = /Mac|mac|iPod|iPhone|iPad/.test(get(navigator, 'userAgentData.platform') || navigator.platform);

export const getActionFromKey = (event: KeyDownEvent) => {

  let ctrlOrMetaKey = isAppleProduct ? (event.ctrlKey || event.metaKey) : event.ctrlKey,
    shiftKey = event.shiftKey,
    altKey = event.altKey;

  if (isAppleProduct) {
    if (event.which === 8) {
      return 'DELETE';
    }
    if (event.metaKey && event.which === 91) { // check for cmd + f in mac for db search
      return 'DB-FIND';
    }
  } else {
    if (event.which === 46) {
      return 'DELETE';
    }
    if (event.ctrlKey && event.which === 70) { // check for ctrl+f for db search
      return 'DB-FIND';
    }
  }

  if (ctrlOrMetaKey) {
    switch (event.which) {
      case 80:
        return altKey ? 'PREVIEW' : 'UNKNOWN';
      case 81:
        return altKey ? 'RUN-DEBUG' : 'UNKNOWN';
      case 82:
        return altKey ? 'RUN' : 'UNKNOWN';
      case 68:
        return altKey ? 'DEPLOY' : 'UNKNOWN';
      case 83:
        return 'SAVE';
      case 88:
        return 'CUT';
      case 67:
        return 'COPY';
      case 86:
        return 'PASTE';
      case 90:
        return event.shiftKey ? 'REDO' : 'UNDO';
      case 37:
        return 'CTRL-LEFT-ARROW';
      case 38:
        return 'CTRL-UP-ARROW';
      case 39:
        return 'CTRL-RIGHT-ARROW';
      case 40:
        return 'CTRL-DOWN-ARROW';
    }
  } else if (shiftKey) {
    switch (event.which) {
      case 9:
        return 'SHIFT+TAB';
      case 37:
        return 'SHIFT+LEFT';
      case 38:
        return 'SHIFT+UP';
      case 39:
        return 'SHIFT+RIGHT';
      case 40:
        return 'SHIFT+DOWN';
    }
  } else {
    switch (event.which) {
      case 8:
        return 'BACKSPACE';
      case 9:
        return 'TAB';
      case 13:
        return 'ENTER';
      case 27:
        return 'ESC';
      case 37:
        return 'LEFT-ARROW';
      case 38:
        return 'UP-ARROW';
      case 39:
        return 'RIGHT-ARROW';
      case 40:
        return 'DOWN-ARROW';
    }
  }

  return 'UNKNOWN';
}
export function isImageFile(fileName: any) {
  return (REGEX.SUPPORTED_IMAGE_FORMAT).test(fileName);
}
export function isTextLikeFile(fileName: any) {
  return (REGEX.SUPPORTED_FILE_FORMAT).test(fileName);
}
export function isDockerFile(fileName: any) {
  return ((fileName.split(".")).indexOf("Dockerfile") > -1);
}

/* convert camelCase string to a snake-case string */
export function hyphenate(name: string) {
  return name.replace(REGEX.SNAKE_CASE, function (letter, pos) {
    return (pos ? '-' : '') + letter.toLowerCase();
  });
}

/* convert a hyphenated string to a space separated string. */
export function deHyphenate(name: string) {
  return name.split('-').join(' ');
}

// Generate default field definition object for a given field
export function getFieldDefProps(title: string, namePrefix?: string, options?: any) {
  let modifiedTitle,
    relatedTable,
    relatedField,
    relatedInfo,
    fieldName,
    isRelated;
  options = options || {};
  if (includes(title, '.')) {
    relatedInfo = split(title, '.');
    relatedTable = relatedInfo[0];
    relatedField = relatedInfo[1];
    isRelated = true;
  }
  if (options.noModifyTitle) {
    modifiedTitle = title;
  } else {
    if (isString(title)) {
      modifiedTitle = prettifyLabel(title);
      modifiedTitle = deHyphenate(modifiedTitle);
      modifiedTitle = namePrefix ? initCaps(namePrefix) + ' ' + modifiedTitle : modifiedTitle;
    } else {
      modifiedTitle = title;
    }
  }
  title = namePrefix ? namePrefix + '.' + title : title;
  if (isRelated) {
    //For related columns, shorten the title to last two words
    fieldName = split(modifiedTitle, ' ');
    fieldName = fieldName.length > 1 ? fieldName[fieldName.length - 2] + ' ' + fieldName[fieldName.length - 1] : fieldName[0];
  } else {
    fieldName = modifiedTitle;
  }
  return options.setBindingField ? { 'displayName': fieldName, 'field': title, 'relatedTable': relatedTable, 'relatedField': relatedField || modifiedTitle } : { 'displayName': fieldName, 'relatedTable': relatedTable, 'relatedField': relatedField || modifiedTitle };
}

/*helper function for prepareFieldDefs*/
export function pushFieldDef(dataObject: any, columnDefObj: any, namePrefix: any, options: any) {
  /*loop over the fields in the dataObject to process them*/
  if (!options) {
    options = {};
  }
  forEach(dataObject, (value, title) => {
    let defObj = getFieldDefProps(title, namePrefix, options);
    /*if field is a leaf node, push it in the columnDefs*/
    if (!isObject(value) || (Array.isArray(value) && !value[0])) {
      /*if the column counter has reached upperBound return*/
      if (options.upperBound && options.columnCount === options.upperBound) {
        return;
      }
      columnDefObj.terminals.push(defObj);
      /*increment the column counter*/
      options.columnCount += 1;
    } else {
      /*else field is an object, process it recursively*/
      /* if parent node to be included, include it */
      if (options.columnCount !== options.upperBound) {
        columnDefObj.objects.push(defObj);
      }

      /* if field is an array node, process its first child */
      if (Array.isArray(value) && value[0]) {
        pushFieldDef(value[0], columnDefObj, title + '[0]', options);
      } else {
        pushFieldDef(value, columnDefObj, title, options);
      }
    }
  });
}

/*function to prepare column definition objects from the data provided*/
export function prepareFieldDefs(data: any, options?: any) {
  let dataObject,
    columnDef = {
      'objects': [],
      'terminals': []
    };
  /*if no data provided, initialize default column definitions*/
  if (!data) {
    data = [];
  }
  if (!options) {
    options = {};
  }
  options.setBindingField = true;
  options.columnCount = 0;
  dataObject = getMetaDataFromData(data);
  /*first of the many data objects from grid data*/
  pushFieldDef(dataObject, columnDef, '', options);
  if (!options || (options && !options.filter)) {
    return columnDef.terminals;
  }
  switch (options.filter) {
    case 'all':
      return columnDef;
    case 'objects':
      return columnDef.objects;
    case 'terminals':
      return columnDef.terminals;
  }
  return columnDef;
}

/*set empty values to all properties of  given object */
export function resetObjectWithEmptyValues(object: any) {
  let properties: any;
  if (object) {
    properties = {};
    forEach(object, (value, key) => {
      properties[key] = '';
    });
  }
  return properties;
}

export function getPropertyNode(prop: any) {
  return {
    'type': prop.type,
    'isPrimaryKey': prop.isPrimaryKey,
    'generator': prop.generator,
    'isRelatedPk': prop.isRelatedPk,
    'systemUpdated': prop.systemUpdated,
    'systemInserted': prop.systemInserted,
    'relatedEntityName': prop.relatedEntityName,
    'notNull': prop.notNull,
    'defaultValue': prop.defaultValue,
    'period': prop.period
  };
}

/* fetch the column names and nested column names from the propertiesMap object */
export function fetchPropertiesMapColumns(propertiesMap: any, namePrefix?: any, options?: any) {
  let objects: any = {}, relatedColumnsArr: any = [], terminals: any = {}, info,
    columns = getClonedObject(propertiesMap.columns);

  /* iterated trough the propertiesMap columns of all levels and build object with columns having required configuration*/
  forEach(columns, (val: any) => {
    /* if the object is nested type repeat the above process for that nested object through recursively */
    if (val.isRelated) {
      if (val.isList) {
        return;
      }
      relatedColumnsArr.push(val);
    } else {
      /* otherwise build object with required configuration */
      let columnName = namePrefix ? namePrefix + '.' + val.fieldName : val.fieldName;
      terminals[columnName] = getPropertyNode(val);
      if (propertiesMap.isRelated) {
        //For related columns, set not null as true for primary keys and not null
        terminals[columnName].notNull = propertiesMap.notNull && val.notNull && val.isPrimaryKey;
      }
    }
  });
  forEach(relatedColumnsArr, function (val) {
    //If a related column doesn't have further columns in it the adding the current column and returning
    if (isEmpty(val.columns)) {
      let relColumnName = namePrefix ? namePrefix + '.' + val.relatedColumnName : val.relatedColumnName;
      terminals[relColumnName] = getPropertyNode(val);
      return;
    }
    forEach(val.columns, function (col) {
      if (val.isRelated) {
        if (col.isPrimaryKey) {
          col.isRelatedPk = 'true';
        }
        col.relatedEntityName = val.relatedEntityName;
      }
    });

    let columnName = namePrefix ? namePrefix + '.' + val.fieldName : val.fieldName;
    objects[columnName] = getPropertyNode(val);
    info = fetchPropertiesMapColumns(val, val.fieldName, options);

    if (!options || (options && !options.filter)) {
      //Extend the terminal object with the inner columns. If already present, ignore them.
      assignWith(terminals, info, function (objValue, srcValue) {
        return isUndefined(objValue) ? srcValue : objValue;
      });
    } else {
      switch (options.filter) {
        case 'all':
          extend(terminals, info.terminals);
          extend(objects, info.objects);
          break;
        case 'objects':
          extend(objects, info);
          break;
        case 'terminals':
          extend(terminals, info);
          break;
      }
    }
  });

  if (!options || (options && !options.filter)) {
    return terminals;
  }
  switch (options.filter) {
    case 'all':
      return { 'objects': objects, 'terminals': terminals };
    case 'objects':
      return objects;
    case 'terminals':
      return terminals;
  }
}

/*function to check if string contains HTML tags.*/
export function isValidHtml(str: string) {
  return REGEX.VALID_HTML.test(str);
}

/*function to get variable name bound to an element*/
export function getVariableName(iScope: any, scope?: any): any {
  if (iScope && iScope.binddataset) {
    let variableName,
      widgetScope,
      widgetName,
      isBoundToVariable,
      isBoundToWidget,
      parts = iScope.binddataset.split('.');

    isBoundToVariable = includes(iScope.binddataset, 'bind:Variables.');

    if (!isBoundToVariable) {
      isBoundToWidget = includes(iScope.binddataset, 'bind:Widgets.');
    }

    if (isBoundToVariable) {
      variableName = parts[1];
    } else if (isBoundToWidget) {
      if (isString(iScope.binddataset) && iScope.binddataset !== '') {
        if (!includes(iScope.binddataset, '.selecteditem')) {
          widgetName = parts[1];
          let _widgets;
          if (!scope) {
            _widgets = iScope.Widgets;
            if (!_widgets) {
              _widgets = iScope.viewParent.Widgets;
            }
          }
          widgetScope = get(_widgets, widgetName);
          variableName = getVariableName(widgetScope);
        } else {
          // Return null if widget is bound to selecteditem.something.
          variableName = null;
        }
      }
    }
    return variableName;
  }
}

/*function to swap two elements in an array*/
export function swapArrayElements(array: any, index1: any, index2: any) {
  let temp = array[index1];
  array[index1] = array[index2];
  array[index2] = temp;
  return array;
}
export const isArrayEqual = (x: any, y: any) => {
  return isEmpty(xorWith(x, y, isEqual));
}

export function getNodeFromJson(tree: any, nodeId: any, parentNodeId?: any) {
  let nodeUId: any,
    parentNodeUId: any,
    nodeIndex: any,
    nodeStartIndex: any,
    node: any;

  /*Loop through the nodeMap of the tree.*/
  forEach(tree[0].nodeMap, (name: any, uid: any) => {
    /*Check if the name matches with the specified nodeId*/
    if (name === nodeId) {
      nodeUId = uid;
      if (!parentNodeId) {
        return false;
      }
      /*Check if the name of the parent node matches with the parentNodeId.
      * If matched, break out of the loop.*/
      parentNodeUId = nodeUId.substr(0, nodeUId.lastIndexOf('-'));
      if (tree[0].nodeMap[parentNodeUId] === parentNodeId) {
        return false;
      }
    }
    return;
  });

  /*Check for sanity.*/
  if (nodeUId) {
    nodeIndex = nodeUId.split('-');
    nodeStartIndex = nodeIndex.shift();
    node = tree[nodeStartIndex];

    /*Get the node based on the nodeIndex*/
    nodeIndex.forEach((index: any) => {
      node = node.children[index];
    });
    return node;
  }
}

export function addNodeToJson(tree: any, nodeId: any, parentNodeUId: any, options: any, parentNodeId?: any) {

  options = options || {};

  let node: any = {
    'id': nodeId,
    'label': options.label,
    'badgeLabel': options.badgeLabel,
    'collapsed': options.collapsed,
    'class': options.class,
    'active': options.active,
    'props': options.nodeProps,
    'isDeletable': options.isDeletable,
    'title': options.title,
    'onDelete': options.onDelete,
    'hasChildren': options.hasChildren,
    'deepSearch': options.deepSearch
  },
    parentIndex: any,
    parentStartIndex: any,
    parentNode: any,
    existingNode: any;

  /*Return if the 'tree' is undefined*/
  if (isUndefined(tree)) {
    return;
  }
  /*If parentNodeUId is not specified, insert the node into the tree and return*/
  if (isUndefined(parentNodeUId) && isUndefined(parentNodeId)) {
    parentNode = tree[0];
  } else {
    if (parentNodeId && !parentNodeUId) {
      parentNodeUId = getNodeFromJson(tree, parentNodeId).uid;
    }
    parentIndex = parentNodeUId.split('-');
    parentStartIndex = parentIndex.shift();
    parentNode = tree[parentStartIndex];
    parentIndex.forEach((index: any) => {
      parentNode = parentNode.children[index];
    });
  }

  /* case, no node in the tree (empty tree) */
  if (!parentNode) {
    /* make it as a root node and push into the tree */
    node.uid = '0';
    node.nodeMap = {
      '0': node.id
    };
    tree.push(node);
    return node;
  }

  /*Case: The tree has no children*/
  if (!(parentNode.children) || !(isArray(parentNode.children))) {
    /*Initialize the tree children*/
    parentNode.children = [];
  } else {
    /*Check if a node with the specified id already exists in the tree children and return if found*/
    existingNode = getNode(parentNode.children, nodeId);
    if (existingNode) {
      return existingNode;
    }
  }
  node.uid = parentNode.uid + '-' + (parentNode.children.length);
  /*Insert the node as a child to the tree and return*/
  parentNode.children.push(node);

  tree[0].nodeMap[node.uid] = nodeId;
  return node;
}

export function getNode(tree: any, nodeId: any) {
  let index, treeLength;
  /*Return undefined if the 'tree' is undefined*/
  if (isUndefined(tree)) {
    return undefined;
  }
  treeLength = tree.length;
  /*Loop through the tree and match the specified nodeId against the ids of the tree elements*/
  for (index = 0; index < treeLength; index += 1) {
    /*Return the node if it exists*/
    if (tree[index].id === nodeId) {
      return tree[index];
    }
  }
  /*Return undefined if the tree does not contain the node*/
  return undefined;
}

export function isFileSizeWithinLimit(file: any, sizeInMb: any): boolean {
  let FILESIZE_MB: number = 1048576;
  let FILE_MAX_SIZE: number = sizeInMb * FILESIZE_MB;
  return file.size < FILE_MAX_SIZE;
}

export function isZipFile(fileName: any): boolean {
  return (REGEX.ZIP_FILE).test(fileName);
}

export function isExeFile(fileName: string): boolean {
  return (REGEX.EXE_FILE).test(fileName);
}

export function isJarFile(fileName: string): boolean {
  return (REGEX.JAR_FILE).test(fileName);
}

export function isAudioFile(fileName: string): boolean {
  return (REGEX.SUPPORTED_AUDIO_FORMAT).test(fileName);
}

export function isVideoFile(fileName: string): boolean {
  return (REGEX.SUPPORTED_VIDEO_FORMAT).test(fileName);
}

export function getProjectResourcePath(projectID: string): string {
  return environment.SERVICES_BASE_PATH + "services/projects/" + projectID + "/resources/content/web/";
}

export function getProjectPath(projectID: string): string {
  return environment.SERVICES_BASE_PATH + "services/projects/" + projectID + "/resources/content/project";
}

export function getPrefabIconUrl(iconUrl: string, projectId: string): string {
  //replace the special characters except / .  - with _
  let url = getProjectResourcePath(projectId) + iconUrl.replace(/[^A-Z0-9\/\.\-]/ig, "_");
  // @ts-ignore
  url = removeExtraSlashes(url);
  return url;
}

export function isNewVerGreaterThanCurrentVer(currentVersion: any, latestVersion: any) {
  // using semver library to compare versions
  let currentVerParts = currentVersion.split('.'),
      latestVerParts = latestVersion.split('.');

  currentVersion = currentVerParts.length == 2 ? currentVersion + '.0' : (currentVerParts.length == 1 ? currentVersion + '.0.0': currentVersion);
  latestVersion = latestVerParts.length == 2 ? latestVersion + '.0' :  (latestVerParts.length == 1 ? latestVersion + '.0.0' : latestVersion);
  if (semver.compare(latestVersion, currentVersion) === 1) {
    return true;
  }
  return false;
}

export function isValidAppServerUrl(url: string) {
  return (REGEX.APP_SERVER_URL_FORMAT).test(url);
}

export function isValidMobileAppId(appId: string) {
  return !!REGEX.MOBILE_APP_ID.test(appId);
}

/* returns true if HTML5 File API is available else false*/
export function isFileUploadSupported() {
  return (window.File && window.FileReader && window.FileList && window.Blob);
}

export  function updateUrlParams(params: UrlParam[], router: Router , activatedRoute: ActivatedRoute, isReplaceState: boolean = true) {
  const queryParamsObj = { ...activatedRoute.snapshot.queryParams };
  const fragmentParams = new URLSearchParams(activatedRoute.snapshot.fragment || '');

  params.forEach(({ key, value, isFragment }) => {
    if (isFragment) {
      value == null ? fragmentParams.delete(key) : fragmentParams.set(key, String(value));
    } else {
      value == null ? delete queryParamsObj[key] : (queryParamsObj[key] = value);
    }
  });
  const fragment = fragmentParams.toString();
  router.navigate([], {
    relativeTo: activatedRoute,
    queryParams: queryParamsObj,
    fragment: fragment || undefined,
    replaceUrl: isReplaceState
  });
}

export function updateCursorPosition(router: Router, route: ActivatedRoute, pos?: any, editorComponent?: any) {
  if(editorComponent && editorComponent.wmsEditor) {
    if(pos) {
      updateUrlParams([
        { key: "l", value: pos.lineNumber || 1 },
      ], router, route)
    }
  }
}
export function fileUploadFallback(uploadConfig:any , successCallback: any, errorCallback: any) {
  /*creating a hidden iframe to facilitate file upload by way of form submit.*/
  let iFrameElement = $('<iframe id="fileUploadIFrame" name="fileUploadIFrame" class="ng-hide"></iframe>'),
      formElement,
      formAction,
      dataArray,
      index,
      dataObj,
      dataElement,
      elementName,
      elementValue,
      key;

  if (uploadConfig) {
      formAction = uploadConfig.url;
  }

  /*appending iframe element to the body*/
  $('body').append(iFrameElement);

  /*event handler for handling load event of iframe*/
  iFrameElement.on('load', function (evt) {
      handleUploadIFrameOnLoad(iFrameElement, successCallback, errorCallback, evt);
  });

  formElement = $('*[name=' + uploadConfig.formName + ']').first();

  /*creating fields which are necessary as params for importing resources.*/
  if (uploadConfig.data) {
      dataArray = uploadConfig.data;
      /*iterating over data array*/
      for (index = 0; index < dataArray.length; index += 1) {
          dataObj = dataArray[index];
          /*iterating over each object to get element name and element value*/
          for (key in dataObj) {
              if (dataObj.hasOwnProperty(key)) {
                  elementName = key;
                  elementValue = dataObj[key];
              }
          }
          /*creating element using element name and value obtained.*/
          dataElement = $('<input type="hidden" name="' + elementName + '" value="' + elementValue + '"/>');
          /*appending element to formElement*/
          formElement.append(dataElement);
      }
  }

  /*setting form attributes before form submit. Applying iframe as form target to avoid page reflow.*/
  formElement.attr({
      'target'  : 'fileUploadIFrame',
      'action'  : formAction,
      'method'  : 'post',
      'enctype' : 'multipart/form-data',
      'encoding': 'multipart/form-data'
  });

  /*triggering the form submit event*/
  formElement.submit();
}

function handleUploadIFrameOnLoad(iFrameElement:any, successCallback: any, errorCallback: any, evt: any) {
  let serverResponse;
  /*removing event listener for the iframe*/
  iFrameElement.off('load', handleUploadIFrameOnLoad);
  /*obtaining the server response of the form submit and prefab import*/
  serverResponse = $('#fileUploadIFrame').contents().find('body').text();
  if (evt && evt.currentTarget) {
      evt.currentTarget.responseText = serverResponse;
  }
  /*removing the iframe element from the DOM markup after import/upload is successful.*/
  iFrameElement.first().remove();
  /*triggering the callback function when succes response is encountered*/
  if (!(<any>serverResponse).errorDetails) {
      triggerFn(successCallback,  evt);
  } else {
      triggerFn(errorCallback);
  }
}

/*function to check if the stylesheet is already loaded */
function isStyleSheetLoaded(href: string) {
  return !!document.querySelector('link[href="' + href + '"]');
}

/*function to load a stylesheet */
export function loadStyleSheet(url: string, attr?: any) {
  if (isStyleSheetLoaded(url)) {
    return;
  }

  const link = document.createElement('link');
  link.href = url;
  link.rel = 'stylesheet';
  link.type = 'text/css';

  /*To add attributes to link tag*/
  if (attr && attr.name) {
    link.setAttribute(attr.name, attr.value);
  }

  const headNode = document.getElementsByTagName('head')[0];
  headNode.appendChild(link);

  return link;
}

export const CURRENCYCONSTANTS: any = {
  "USD": {
    "symbol": "$",
    "name": "US Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "USD",
    "name_plural": "US dollars"
  },
  "CAD": {
    "symbol": "CA$",
    "name": "Canadian Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "CAD",
    "name_plural": "Canadian dollars"
  },
  "EUR": {
    "symbol": "€",
    "name": "Euro",
    "symbol_native": "€",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "EUR",
    "name_plural": "euros"
  },
  "AED": {
    "symbol": "AED",
    "name": "United Arab Emirates Dirham",
    "symbol_native": "د.إ.‏",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "AED",
    "name_plural": "UAE dirhams"
  },
  "AFN": {
    "symbol": "Af",
    "name": "Afghan Afghani",
    "symbol_native": "؋",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "AFN",
    "name_plural": "Afghan Afghanis"
  },
  "ALL": {
    "symbol": "ALL",
    "name": "Albanian Lek",
    "symbol_native": "Lek",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "ALL",
    "name_plural": "Albanian lekë"
  },
  "AMD": {
    "symbol": "AMD",
    "name": "Armenian Dram",
    "symbol_native": "դր.",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "AMD",
    "name_plural": "Armenian drams"
  },
  "ARS": {
    "symbol": "AR$",
    "name": "Argentine Peso",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "ARS",
    "name_plural": "Argentine pesos"
  },
  "AUD": {
    "symbol": "AU$",
    "name": "Australian Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "AUD",
    "name_plural": "Australian dollars"
  },
  "AZN": {
    "symbol": "man.",
    "name": "Azerbaijani Manat",
    "symbol_native": "ман.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "AZN",
    "name_plural": "Azerbaijani manats"
  },
  "BAM": {
    "symbol": "KM",
    "name": "Bosnia-Herzegovina Convertible Mark",
    "symbol_native": "KM",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BAM",
    "name_plural": "Bosnia-Herzegovina convertible marks"
  },
  "BDT": {
    "symbol": "Tk",
    "name": "Bangladeshi Taka",
    "symbol_native": "৳",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BDT",
    "name_plural": "Bangladeshi takas"
  },
  "BGN": {
    "symbol": "BGN",
    "name": "Bulgarian Lev",
    "symbol_native": "лв.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BGN",
    "name_plural": "Bulgarian leva"
  },
  "BHD": {
    "symbol": "BD",
    "name": "Bahraini Dinar",
    "symbol_native": "د.ب.‏",
    "decimal_digits": 3,
    "rounding": 0,
    "code": "BHD",
    "name_plural": "Bahraini dinars"
  },
  "BIF": {
    "symbol": "FBu",
    "name": "Burundian Franc",
    "symbol_native": "FBu",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "BIF",
    "name_plural": "Burundian francs"
  },
  "BND": {
    "symbol": "BN$",
    "name": "Brunei Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BND",
    "name_plural": "Brunei dollars"
  },
  "BOB": {
    "symbol": "Bs",
    "name": "Bolivian Boliviano",
    "symbol_native": "Bs",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BOB",
    "name_plural": "Bolivian bolivianos"
  },
  "BRL": {
    "symbol": "R$",
    "name": "Brazilian Real",
    "symbol_native": "R$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BRL",
    "name_plural": "Brazilian reals"
  },
  "BWP": {
    "symbol": "BWP",
    "name": "Botswanan Pula",
    "symbol_native": "P",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BWP",
    "name_plural": "Botswanan pulas"
  },
  "BYR": {
    "symbol": "BYR",
    "name": "Belarusian Ruble",
    "symbol_native": "BYR",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "BYR",
    "name_plural": "Belarusian rubles"
  },
  "BZD": {
    "symbol": "BZ$",
    "name": "Belize Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "BZD",
    "name_plural": "Belize dollars"
  },
  "CDF": {
    "symbol": "CDF",
    "name": "Congolese Franc",
    "symbol_native": "FrCD",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "CDF",
    "name_plural": "Congolese francs"
  },
  "CHF": {
    "symbol": "CHF",
    "name": "Swiss Franc",
    "symbol_native": "CHF",
    "decimal_digits": 2,
    "rounding": 0.05,
    "code": "CHF",
    "name_plural": "Swiss francs"
  },
  "CLP": {
    "symbol": "CL$",
    "name": "Chilean Peso",
    "symbol_native": "$",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "CLP",
    "name_plural": "Chilean pesos"
  },
  "CNY": {
    "symbol": "CN¥",
    "name": "Chinese Yuan",
    "symbol_native": "CN¥",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "CNY",
    "name_plural": "Chinese yuan"
  },
  "COP": {
    "symbol": "CO$",
    "name": "Colombian Peso",
    "symbol_native": "$",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "COP",
    "name_plural": "Colombian pesos"
  },
  "CRC": {
    "symbol": "₡",
    "name": "Costa Rican Colón",
    "symbol_native": "₡",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "CRC",
    "name_plural": "Costa Rican colóns"
  },
  "CVE": {
    "symbol": "CV$",
    "name": "Cape Verdean Escudo",
    "symbol_native": "CV$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "CVE",
    "name_plural": "Cape Verdean escudos"
  },
  "CZK": {
    "symbol": "Kč",
    "name": "Czech Republic Koruna",
    "symbol_native": "Kč",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "CZK",
    "name_plural": "Czech Republic korunas"
  },
  "DJF": {
    "symbol": "Fdj",
    "name": "Djiboutian Franc",
    "symbol_native": "Fdj",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "DJF",
    "name_plural": "Djiboutian francs"
  },
  "DKK": {
    "symbol": "Dkr",
    "name": "Danish Krone",
    "symbol_native": "kr",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "DKK",
    "name_plural": "Danish kroner"
  },
  "DOP": {
    "symbol": "RD$",
    "name": "Dominican Peso",
    "symbol_native": "RD$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "DOP",
    "name_plural": "Dominican pesos"
  },
  "DZD": {
    "symbol": "DA",
    "name": "Algerian Dinar",
    "symbol_native": "د.ج.‏",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "DZD",
    "name_plural": "Algerian dinars"
  },
  "EEK": {
    "symbol": "Ekr",
    "name": "Estonian Kroon",
    "symbol_native": "kr",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "EEK",
    "name_plural": "Estonian kroons"
  },
  "EGP": {
    "symbol": "EGP",
    "name": "Egyptian Pound",
    "symbol_native": "ج.م.‏",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "EGP",
    "name_plural": "Egyptian pounds"
  },
  "ERN": {
    "symbol": "Nfk",
    "name": "Eritrean Nakfa",
    "symbol_native": "Nfk",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "ERN",
    "name_plural": "Eritrean nakfas"
  },
  "ETB": {
    "symbol": "Br",
    "name": "Ethiopian Birr",
    "symbol_native": "Br",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "ETB",
    "name_plural": "Ethiopian birrs"
  },
  "GBP": {
    "symbol": "£",
    "name": "British Pound Sterling",
    "symbol_native": "£",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "GBP",
    "name_plural": "British pounds sterling"
  },
  "GEL": {
    "symbol": "GEL",
    "name": "Georgian Lari",
    "symbol_native": "GEL",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "GEL",
    "name_plural": "Georgian laris"
  },
  "GHS": {
    "symbol": "GH₵",
    "name": "Ghanaian Cedi",
    "symbol_native": "GH₵",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "GHS",
    "name_plural": "Ghanaian cedis"
  },
  "GNF": {
    "symbol": "FG",
    "name": "Guinean Franc",
    "symbol_native": "FG",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "GNF",
    "name_plural": "Guinean francs"
  },
  "GTQ": {
    "symbol": "GTQ",
    "name": "Guatemalan Quetzal",
    "symbol_native": "Q",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "GTQ",
    "name_plural": "Guatemalan quetzals"
  },
  "HKD": {
    "symbol": "HK$",
    "name": "Hong Kong Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "HKD",
    "name_plural": "Hong Kong dollars"
  },
  "HNL": {
    "symbol": "HNL",
    "name": "Honduran Lempira",
    "symbol_native": "L",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "HNL",
    "name_plural": "Honduran lempiras"
  },
  "HRK": {
    "symbol": "kn",
    "name": "Croatian Kuna",
    "symbol_native": "kn",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "HRK",
    "name_plural": "Croatian kunas"
  },
  "HUF": {
    "symbol": "Ft",
    "name": "Hungarian Forint",
    "symbol_native": "Ft",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "HUF",
    "name_plural": "Hungarian forints"
  },
  "IDR": {
    "symbol": "Rp",
    "name": "Indonesian Rupiah",
    "symbol_native": "Rp",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "IDR",
    "name_plural": "Indonesian rupiahs"
  },
  "ILS": {
    "symbol": "₪",
    "name": "Israeli New Sheqel",
    "symbol_native": "₪",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "ILS",
    "name_plural": "Israeli new sheqels"
  },
  "INR": {
    "symbol": "₹",
    "name": "Indian Rupee",
    "symbol_native": "টকা",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "INR",
    "name_plural": "Indian rupees"
  },
  "IQD": {
    "symbol": "IQD",
    "name": "Iraqi Dinar",
    "symbol_native": "د.ع.‏",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "IQD",
    "name_plural": "Iraqi dinars"
  },
  "IRR": {
    "symbol": "IRR",
    "name": "Iranian Rial",
    "symbol_native": "﷼",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "IRR",
    "name_plural": "Iranian rials"
  },
  "ISK": {
    "symbol": "Ikr",
    "name": "Icelandic Króna",
    "symbol_native": "kr",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "ISK",
    "name_plural": "Icelandic krónur"
  },
  "JMD": {
    "symbol": "J$",
    "name": "Jamaican Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "JMD",
    "name_plural": "Jamaican dollars"
  },
  "JOD": {
    "symbol": "JD",
    "name": "Jordanian Dinar",
    "symbol_native": "د.أ.‏",
    "decimal_digits": 3,
    "rounding": 0,
    "code": "JOD",
    "name_plural": "Jordanian dinars"
  },
  "JPY": {
    "symbol": "¥",
    "name": "Japanese Yen",
    "symbol_native": "￥",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "JPY",
    "name_plural": "Japanese yen"
  },
  "KES": {
    "symbol": "Ksh",
    "name": "Kenyan Shilling",
    "symbol_native": "Ksh",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "KES",
    "name_plural": "Kenyan shillings"
  },
  "KHR": {
    "symbol": "KHR",
    "name": "Cambodian Riel",
    "symbol_native": "៛",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "KHR",
    "name_plural": "Cambodian riels"
  },
  "KMF": {
    "symbol": "CF",
    "name": "Comorian Franc",
    "symbol_native": "FC",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "KMF",
    "name_plural": "Comorian francs"
  },
  "KRW": {
    "symbol": "₩",
    "name": "South Korean Won",
    "symbol_native": "₩",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "KRW",
    "name_plural": "South Korean won"
  },
  "KWD": {
    "symbol": "KD",
    "name": "Kuwaiti Dinar",
    "symbol_native": "د.ك.‏",
    "decimal_digits": 3,
    "rounding": 0,
    "code": "KWD",
    "name_plural": "Kuwaiti dinars"
  },
  "KZT": {
    "symbol": "KZT",
    "name": "Kazakhstani Tenge",
    "symbol_native": "тңг.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "KZT",
    "name_plural": "Kazakhstani tenges"
  },
  "LBP": {
    "symbol": "LB£",
    "name": "Lebanese Pound",
    "symbol_native": "ل.ل.‏",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "LBP",
    "name_plural": "Lebanese pounds"
  },
  "LKR": {
    "symbol": "SLRs",
    "name": "Sri Lankan Rupee",
    "symbol_native": "SL Re",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "LKR",
    "name_plural": "Sri Lankan rupees"
  },
  "LTL": {
    "symbol": "Lt",
    "name": "Lithuanian Litas",
    "symbol_native": "Lt",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "LTL",
    "name_plural": "Lithuanian litai"
  },
  "LVL": {
    "symbol": "Ls",
    "name": "Latvian Lats",
    "symbol_native": "Ls",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "LVL",
    "name_plural": "Latvian lati"
  },
  "LYD": {
    "symbol": "LD",
    "name": "Libyan Dinar",
    "symbol_native": "د.ل.‏",
    "decimal_digits": 3,
    "rounding": 0,
    "code": "LYD",
    "name_plural": "Libyan dinars"
  },
  "MAD": {
    "symbol": "MAD",
    "name": "Moroccan Dirham",
    "symbol_native": "د.م.‏",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MAD",
    "name_plural": "Moroccan dirhams"
  },
  "MDL": {
    "symbol": "MDL",
    "name": "Moldovan Leu",
    "symbol_native": "MDL",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MDL",
    "name_plural": "Moldovan lei"
  },
  "MGA": {
    "symbol": "MGA",
    "name": "Malagasy Ariary",
    "symbol_native": "MGA",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "MGA",
    "name_plural": "Malagasy Ariaries"
  },
  "MKD": {
    "symbol": "MKD",
    "name": "Macedonian Denar",
    "symbol_native": "MKD",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MKD",
    "name_plural": "Macedonian denari"
  },
  "MMK": {
    "symbol": "MMK",
    "name": "Myanma Kyat",
    "symbol_native": "K",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "MMK",
    "name_plural": "Myanma kyats"
  },
  "MOP": {
    "symbol": "MOP$",
    "name": "Macanese Pataca",
    "symbol_native": "MOP$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MOP",
    "name_plural": "Macanese patacas"
  },
  "MUR": {
    "symbol": "MURs",
    "name": "Mauritian Rupee",
    "symbol_native": "MURs",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "MUR",
    "name_plural": "Mauritian rupees"
  },
  "MXN": {
    "symbol": "MX$",
    "name": "Mexican Peso",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MXN",
    "name_plural": "Mexican pesos"
  },
  "MYR": {
    "symbol": "RM",
    "name": "Malaysian Ringgit",
    "symbol_native": "RM",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MYR",
    "name_plural": "Malaysian ringgits"
  },
  "MZN": {
    "symbol": "MTn",
    "name": "Mozambican Metical",
    "symbol_native": "MTn",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "MZN",
    "name_plural": "Mozambican meticals"
  },
  "NAD": {
    "symbol": "N$",
    "name": "Namibian Dollar",
    "symbol_native": "N$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "NAD",
    "name_plural": "Namibian dollars"
  },
  "NGN": {
    "symbol": "₦",
    "name": "Nigerian Naira",
    "symbol_native": "₦",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "NGN",
    "name_plural": "Nigerian nairas"
  },
  "NIO": {
    "symbol": "C$",
    "name": "Nicaraguan Córdoba",
    "symbol_native": "C$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "NIO",
    "name_plural": "Nicaraguan córdobas"
  },
  "NOK": {
    "symbol": "Nkr",
    "name": "Norwegian Krone",
    "symbol_native": "kr",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "NOK",
    "name_plural": "Norwegian kroner"
  },
  "NPR": {
    "symbol": "NPRs",
    "name": "Nepalese Rupee",
    "symbol_native": "नेरू",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "NPR",
    "name_plural": "Nepalese rupees"
  },
  "NZD": {
    "symbol": "NZ$",
    "name": "New Zealand Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "NZD",
    "name_plural": "New Zealand dollars"
  },
  "OMR": {
    "symbol": "OMR",
    "name": "Omani Rial",
    "symbol_native": "ر.ع.‏",
    "decimal_digits": 3,
    "rounding": 0,
    "code": "OMR",
    "name_plural": "Omani rials"
  },
  "PAB": {
    "symbol": "B/.",
    "name": "Panamanian Balboa",
    "symbol_native": "B/.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "PAB",
    "name_plural": "Panamanian balboas"
  },
  "PEN": {
    "symbol": "S/.",
    "name": "Peruvian Nuevo Sol",
    "symbol_native": "S/.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "PEN",
    "name_plural": "Peruvian nuevos soles"
  },
  "PHP": {
    "symbol": "₱",
    "name": "Philippine Peso",
    "symbol_native": "₱",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "PHP",
    "name_plural": "Philippine pesos"
  },
  "PKR": {
    "symbol": "PKRs",
    "name": "Pakistani Rupee",
    "symbol_native": "₨",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "PKR",
    "name_plural": "Pakistani rupees"
  },
  "PLN": {
    "symbol": "zł",
    "name": "Polish Zloty",
    "symbol_native": "zł",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "PLN",
    "name_plural": "Polish zlotys"
  },
  "PYG": {
    "symbol": "₲",
    "name": "Paraguayan Guarani",
    "symbol_native": "₲",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "PYG",
    "name_plural": "Paraguayan guaranis"
  },
  "QAR": {
    "symbol": "QR",
    "name": "Qatari Rial",
    "symbol_native": "ر.ق.‏",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "QAR",
    "name_plural": "Qatari rials"
  },
  "RON": {
    "symbol": "RON",
    "name": "Romanian Leu",
    "symbol_native": "RON",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "RON",
    "name_plural": "Romanian lei"
  },
  "RSD": {
    "symbol": "din.",
    "name": "Serbian Dinar",
    "symbol_native": "дин.",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "RSD",
    "name_plural": "Serbian dinars"
  },
  "RUB": {
    "symbol": "RUB",
    "name": "Russian Ruble",
    "symbol_native": "руб.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "RUB",
    "name_plural": "Russian rubles"
  },
  "RWF": {
    "symbol": "RWF",
    "name": "Rwandan Franc",
    "symbol_native": "FR",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "RWF",
    "name_plural": "Rwandan francs"
  },
  "SAR": {
    "symbol": "SR",
    "name": "Saudi Riyal",
    "symbol_native": "ر.س.‏",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SAR",
    "name_plural": "Saudi riyals"
  },
  "SDG": {
    "symbol": "SDG",
    "name": "Sudanese Pound",
    "symbol_native": "SDG",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SDG",
    "name_plural": "Sudanese pounds"
  },
  "SEK": {
    "symbol": "Skr",
    "name": "Swedish Krona",
    "symbol_native": "kr",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SEK",
    "name_plural": "Swedish kronor"
  },
  "SGD": {
    "symbol": "S$",
    "name": "Singapore Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "SGD",
    "name_plural": "Singapore dollars"
  },
  "SOS": {
    "symbol": "Ssh",
    "name": "Somali Shilling",
    "symbol_native": "Ssh",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "SOS",
    "name_plural": "Somali shillings"
  },
  "SYP": {
    "symbol": "SY£",
    "name": "Syrian Pound",
    "symbol_native": "ل.س.‏",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "SYP",
    "name_plural": "Syrian pounds"
  },
  "THB": {
    "symbol": "฿",
    "name": "Thai Baht",
    "symbol_native": "฿",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "THB",
    "name_plural": "Thai baht"
  },
  "TND": {
    "symbol": "DT",
    "name": "Tunisian Dinar",
    "symbol_native": "د.ت.‏",
    "decimal_digits": 3,
    "rounding": 0,
    "code": "TND",
    "name_plural": "Tunisian dinars"
  },
  "TOP": {
    "symbol": "T$",
    "name": "Tongan Paʻanga",
    "symbol_native": "T$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "TOP",
    "name_plural": "Tongan paʻanga"
  },
  "TRY": {
    "symbol": "TL",
    "name": "Turkish Lira",
    "symbol_native": "TL",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "TRY",
    "name_plural": "Turkish Lira"
  },
  "TTD": {
    "symbol": "TT$",
    "name": "Trinidad and Tobago Dollar",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "TTD",
    "name_plural": "Trinidad and Tobago dollars"
  },
  "TWD": {
    "symbol": "NT$",
    "name": "New Taiwan Dollar",
    "symbol_native": "NT$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "TWD",
    "name_plural": "New Taiwan dollars"
  },
  "TZS": {
    "symbol": "TSh",
    "name": "Tanzanian Shilling",
    "symbol_native": "TSh",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "TZS",
    "name_plural": "Tanzanian shillings"
  },
  "UAH": {
    "symbol": "₴",
    "name": "Ukrainian Hryvnia",
    "symbol_native": "₴",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "UAH",
    "name_plural": "Ukrainian hryvnias"
  },
  "UGX": {
    "symbol": "USh",
    "name": "Ugandan Shilling",
    "symbol_native": "USh",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "UGX",
    "name_plural": "Ugandan shillings"
  },
  "UYU": {
    "symbol": "$U",
    "name": "Uruguayan Peso",
    "symbol_native": "$",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "UYU",
    "name_plural": "Uruguayan pesos"
  },
  "UZS": {
    "symbol": "UZS",
    "name": "Uzbekistan Som",
    "symbol_native": "UZS",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "UZS",
    "name_plural": "Uzbekistan som"
  },
  "VEF": {
    "symbol": "Bs.F.",
    "name": "Venezuelan Bolívar",
    "symbol_native": "Bs.F.",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "VEF",
    "name_plural": "Venezuelan bolívars"
  },
  "VND": {
    "symbol": "₫",
    "name": "Vietnamese Dong",
    "symbol_native": "₫",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "VND",
    "name_plural": "Vietnamese dong"
  },
  "XAF": {
    "symbol": "FCFA",
    "name": "CFA Franc BEAC",
    "symbol_native": "FCFA",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "XAF",
    "name_plural": "CFA francs BEAC"
  },
  "XOF": {
    "symbol": "CFA",
    "name": "CFA Franc BCEAO",
    "symbol_native": "CFA",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "XOF",
    "name_plural": "CFA francs BCEAO"
  },
  "YER": {
    "symbol": "YR",
    "name": "Yemeni Rial",
    "symbol_native": "ر.ي.‏",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "YER",
    "name_plural": "Yemeni rials"
  },
  "ZAR": {
    "symbol": "R",
    "name": "South African Rand",
    "symbol_native": "R",
    "decimal_digits": 2,
    "rounding": 0,
    "code": "ZAR",
    "name_plural": "South African rand"
  },
  "ZMK": {
    "symbol": "ZK",
    "name": "Zambian Kwacha",
    "symbol_native": "ZK",
    "decimal_digits": 0,
    "rounding": 0,
    "code": "ZMK",
    "name_plural": "Zambian kwachas"
  }
}

/*
 * scrolls the given element into the visible area of the container.
 * @params: {element} element to be scrolled in to view
 * @params: {container} container of the element
 */
export function scrollIntoView(element: any, container?: any, offSetParent?: any) {
  let $container = $(container),
    $element = $(element),
    containerTop: any = $container.scrollTop(),
    containerHeight: any = $container.height(),
    containerBottom = containerTop + containerHeight,
    elemTop = $element[0] && $element[0].offsetTop,
    elemBottom,
    $parent;
  //If parent is passed, conside the parent offset element also
  if (offSetParent) {
    $parent = $element.parents(offSetParent);
    if ($parent.length) {
      elemTop = elemTop + $parent[0].offsetTop + $element.height();
    }
  }
  elemBottom = elemTop + $element.height();
  if (elemTop < containerTop) {
    $container.scrollTop(elemTop);
  } else if (elemBottom > containerBottom) {
    $container.scrollTop(elemBottom - containerHeight);
  }
}

/*function to check if quotes (both single and double) are NOT present in a string.*/
export function isQuoteNotPresent(str: string) {
  return REGEX.NO_QUOTES_ALLOWED.test(str);
}

//function to check if string contains double quotes
export function isNoDoubleQuoteNotPresent(str: string) {
  return REGEX.NO_DOUBLE_QUOTES_ALLOWED.test(str);
}

export function replace(template: any, map: any, parseError?: any) {
  let regEx = REGEX.REPLACE_PATTERN;
  if (!template) {
    return;
  }

  if (parseError) {
    regEx = /\{([^\}]+)\}/g;
  }
  return template.replace(regEx, (match: any, key: any) => {
    return get(map, key);
  });
}

//converts the csv representation of roles to array
export function getWidgetRolesArrayFromStr(val: string | undefined) {
  let UNICODE_COMMA_REGEX = /&#44;/g;

  val = val || '';
  if (val === '') {
    return [];
  }
  // replace the unicode equivalent of comma with comma
  return split(val, ',').map((v: any) => {
    return trim(v).replace(UNICODE_COMMA_REGEX, ',');
  });
}

const SYSTEM_FOLDER_PATHS: any = {
  "audio": ["resources/audios"],
  "connectors": ["WEB-INF/connectors"],
  "image": ["resources/images", "resources/images/imagelists"],
  "jar": ["../lib"],
  "project": ["../project", "../project/i18n", "../project/lib", "../project/services", "../project/src", "..project/src/main", "../project/src/main/webapp", "..project/src/main/resources", "../project/src/main/webapp/resources", "../project/src/main/webapp/resources/audios", "../project/src/main/webapp/resources/images", "../project/src/main/webapp/resources/images/imagelists", "../project/src/main/webapp/resources/videos", "../project/src/main/webapp/resources/i18n", "../project/src/main/webapp/pages", "../project/src/main/webapp/WEB-INF"],
  "resources": ["/resources", "/resources/i18n", "/resources/audios", "/resources/videos", "/resources/images", "/resources/images/imagelists", "/WEB-INF", "/pages", ""],
  "services": ["../services"],
  "video": ["resources/videos"]
}

export function deleteResourceRestricted(context: string, path: string): boolean {
  return (SYSTEM_FOLDER_PATHS[context] && SYSTEM_FOLDER_PATHS[context].indexOf(path) !== -1);
}

/**
 * function which splits the expression based on Operators
 * @param string, string which will be split
 * @returns a list of strings after splitting based on Operators**/
export function splitExpression(expression: any) {
  return expression && expression.split(bindExpressionRegEx);
}

/*function to check valid java package name*/
export function isValidJavaPackageName(pkgName: string) {
  /*
   * Matches fully qualified java class name
   * eg:
   * 1) com.WaveMaker.javaService --> true
   * 2) $com.$WaveMaker.$javaService --> true
   * 3) 1com.2WaveMaker.3javaService --> false numerics at the beginning of the class is not allowed
   * 4) com.W@veM@ker.j@v@Serv!ce --> false
   *
   */
  let VALID_CLASS_NAME_REGEX = /^([a-zA-Z_$][\w$]*\.)*[a-zA-Z_$][\w$]*$/;
  return VALID_CLASS_NAME_REGEX.test(pkgName);
}

export function addResizableClass(className: string) {
  let resizableElement = $('.wm-studio-content');
  $(resizableElement).addClass(className);
}
export function removeResizableClass(className: string) {
  const resizableElement = $(".wm-studio-content");
  $(resizableElement).removeClass(className);
}


export function resetFileObjectsList() {
  listOfFiles = {}
}
export function getFileObject(fileName:any) {
  return listOfFiles[fileName]
}
export  function cacheFileObjects(fileName: string | number, file: any) {
  listOfFiles[fileName] = file
}
export function isFileObject(fileObj: any) {
  return fileObj instanceof File
}

export function getCanvasElement() : any {
  const shadowHost = document.querySelector('wms-canvas-sandbox-wrapper');
  return shadowHost?.shadowRoot ? shadowHost.shadowRoot.querySelector('.domcontent') : document.querySelector('.domcontent');
}

//removes canvas element and shadowdom from the dom
export function removeShadowdom(): any {
  $(getCanvasElement()).remove();
  $(document.getElementsByTagName('wms-canvas-sandbox-wrapper')[0]).remove();
}

// converts style token to css variable
export function convertTokenToVariable(tokens: any, category: any, key: any, nameOverride?: string): any {
  const finalName = nameOverride || key;
  const cssVarName = `--wm-${finalName.endsWith('.@') ? finalName.replace('.@', '').replace(/\./g, '-') : finalName.replace(/\.@/g, '-').replace(/[.@]/g, '-')}`;
  let cssVarValue = tokens[category][key];

  //color tokens
  const match = cssVarValue.match(/^{(.*)\.@\.value}$/);
  if (match) {
    const path = match[1];
    const nestedVarName = `--wm-${path.replace(/\./g, '-')}`;
    cssVarValue = `var(${nestedVarName})`;
  }
  //other tokens
  else if ((/value/).test(cssVarValue)) {
    let modifiedVal = cssVarValue.replace('{', '').replace('}', '').split('.value')[0].replace(/\./g, '-');
    cssVarValue = `var(--wm-${modifiedVal})`;
  }
  return { cssVarName, cssVarValue };
}

/**
 * Checks whether the given changeSet contains any design token override changes.
 *
 * @param changeSet - Change metadata containing merged file information
 * @returns true if any token override file is modified, otherwise false
 */
export function hasTokenOverrideChanges(changeSet: any) {
  let listOfChangesObj = changeSet?.mergedFiles;
  let hasTokenChanges = false;

  if (listOfChangesObj) {
    for (const fileName in listOfChangesObj) {
      if (fileName.includes("overrides")) {
        hasTokenChanges = true;
        return hasTokenChanges;
      }
    }
  }
  return hasTokenChanges;
}
